import { apiGet, apiPost, apiFilePost } from '../../api/api-configuration';
import { failureAction, getAuthorizationAccessToken, downloadFileBlob } from '../../app-actions';
import { escapeHTML } from '../ssm-homepage/ssm-homepage.actions';
import {
  API_GET_AMC_CUSTOMER_DATA_ENDPOINT,
  API_INITIATE_GET_AMC_CUSTOMER_DATA,
  API_COMPLETE_GET_AMC_CUSTOMER_DATA,
  API_POST_AMC_CUSTOMER_DATA_ENDPOINT,
  API_INITIATE_SUBMIT_AMC_CUSTOMER_DATA,
  API_COMPLETE_SUBMIT_AMC_CUSTOMER_DATA,
  API_INITIATE_POST_AMC_OPTIMIZE_PLAN_DATA,
  API_COMPLETE_POST_AMC_OPTIMIZE_PLAN_DATA,
  API_POST_AMC_OPTIMIZE_PLAN_DATA_ENDPOINT,
  NGM_NO_TEXT,
  INITIATE_AMC_CALLBACK_REQUEST,
  COMPLETE_AMC_CALLBACK_REQUEST,
  AMC_CALLBACK_REQUEST_ENDPOINT,
  INITIATE_AMC_DOWNLOAD_PROPOSAL_REQUEST,
  COMPLETE_AMC_DOWNLOAD_PROPOSAL_REQUEST,
  AMC_DOWNLOAD_PROPOSAL_REQUEST_ENDPOINT,
} from '../../app-constants';

export const successActionAMCCustomerData = (response) => {
  const { data } = response;
  return { type: API_COMPLETE_GET_AMC_CUSTOMER_DATA, data };
};

export const getAMCCustomerData = data => (dispatch) => {
  const endpoint = `${API_GET_AMC_CUSTOMER_DATA_ENDPOINT}&value=${encodeURIComponent(window.parent.tcom.researchInsights.appConfig.currentAccount)}`;
  dispatch({ type: API_INITIATE_GET_AMC_CUSTOMER_DATA });
  apiGet(dispatch, endpoint, successActionAMCCustomerData, failureAction, data);
};

export const successActionSubmitAMC = () => (
  { type: API_COMPLETE_SUBMIT_AMC_CUSTOMER_DATA }
);

export const submitAMCCustomerData = data => (dispatch) => {
  const endpoint = `${API_POST_AMC_CUSTOMER_DATA_ENDPOINT}&value=${encodeURIComponent(window.parent.tcom.researchInsights.appConfig.currentAccount)}`;

  const bearerToken = getAuthorizationAccessToken();
  if (bearerToken !== 'Bearer undefined') {
    dispatch({ type: API_INITIATE_SUBMIT_AMC_CUSTOMER_DATA });
    apiFilePost(dispatch, endpoint, successActionSubmitAMC, failureAction, data);
  } else {
    setTimeout(() => {
      console.log('sending the request delayed');
      dispatch({ type: API_INITIATE_SUBMIT_AMC_CUSTOMER_DATA });
      apiFilePost(dispatch, endpoint, successActionSubmitAMC, failureAction, data);
    }, 7000);
  }
};

export const successActionDownloadCustomerProposal = (response) => {
  downloadFileBlob(response, 'Customer-proposal.docx', 'application/vnd.ms-word');
  return { type: COMPLETE_AMC_DOWNLOAD_PROPOSAL_REQUEST };
};


export const downloadCustomerProposal = data => (dispatch) => {
  const currentAccount = window.parent.tcom.researchInsights.appConfig.currentAccount;
  const endpoint = `${AMC_DOWNLOAD_PROPOSAL_REQUEST_ENDPOINT}&value=${encodeURIComponent(currentAccount)}`;
  dispatch({ type: INITIATE_AMC_DOWNLOAD_PROPOSAL_REQUEST });
  apiFilePost(dispatch, endpoint, successActionDownloadCustomerProposal, failureAction, data);
};

export const successActionSubmitAMCRecommendPlan = (response) => {
  const { data } = response;
  return { type: API_COMPLETE_POST_AMC_OPTIMIZE_PLAN_DATA, data };
};


export const submitAMCOptimizePlanData = data => (dispatch) => {
  const endpoint = `${API_POST_AMC_OPTIMIZE_PLAN_DATA_ENDPOINT}&value=${encodeURIComponent(window.parent.tcom.researchInsights.appConfig.currentAccount)}`; // eslint-disable-line  
  const bearerToken = getAuthorizationAccessToken();
  if (bearerToken !== 'Bearer undefined') {
    dispatch({ type: API_INITIATE_POST_AMC_OPTIMIZE_PLAN_DATA });
    apiPost(dispatch, endpoint, successActionSubmitAMCRecommendPlan, failureAction, data);
  } else {
    setTimeout(() => {
      console.log('sending the request delayed');
      dispatch({ type: API_INITIATE_POST_AMC_OPTIMIZE_PLAN_DATA });
      apiPost(dispatch, endpoint, successActionSubmitAMCRecommendPlan, failureAction, data);
    }, 3000);
  }
};

export const preparePostCallArray = (stateData, customerQuestionAuthorable) => {
  let preparedata = {};
  const prepareRecommendations = [];
  stateData.performanceSelectedOptions.map((options) => {
    const [questionIndex, selectedValue] = options.split('-');
    prepareRecommendations.push({
      question: customerQuestionAuthorable.performanceQuestions[questionIndex].questionText,
      answer: customerQuestionAuthorable.performanceQuestions[questionIndex].options[parseInt(selectedValue, 10) - 1] !== undefined ?
        customerQuestionAuthorable.performanceQuestions[questionIndex].options[parseInt(selectedValue, 10) - 1].value : '',
    });
    return true;
  });

  Object.keys(stateData.customerSelectedOptions).map((key) => {
    const recommendation = {
      question: customerQuestionAuthorable.questions[parseInt(key, 10) - 1].questionText,
      answer: stateData.customerSelectedOptions[key].join('|'),
    };
    return prepareRecommendations.push(recommendation);
  });

  preparedata = {
    captureUserSelections: prepareRecommendations,
    comments: escapeHTML(stateData.preferredTimeContacted),
    recommendedPlan: stateData.recommendedPlanType,
    searchUsed: stateData.searchUsed,
    addOnLinks: window.tcom.researchInsights.appConfig.ngmAddonsClickedTexts,
    liveChatUsed: NGM_NO_TEXT,
  };
  return preparedata;
};

export const prepareSubmitAMCData = (baseData, serviceDetails, calculationData) => {
  const submitData = {
    ...baseData,
    serviceNumbers: serviceDetails,
    calculations: { ...calculationData },
  };
  const data = {
    data: submitData,
  };
  return data;
};

export const deviceOnAppleData = (tradeOfferContent, tradeDropDownData) => {
  const deviceDataValues = Object.values(tradeDropDownData).filter(val => val !== 'NOSELECTION');
  const iphoneDropDownList = tradeOfferContent.formFields.tradeIphoneDropDown.options.filter(opt => opt.key !== 'NOSELECTION');

  const deviceCountData = iphoneDropDownList.map((iphone) => {
    const deviceName = iphone.value;
    const deviceCount = deviceDataValues.filter(device => device === iphone.key).length;
    return {
      deviceName,
      devicesChosen: deviceCount,
    };
  });

  return deviceCountData.filter(deviceData => deviceData.devicesChosen > 0);
};

const getNumbersMatchingCurrentPlan = (planName, serviceDetails) => {
  const numberOnPlan = serviceDetails.map((service) => {
    if (service.currentPlan === planName) {
      return service.serviceNumber;
    }
    return '';
  });
  return numberOnPlan.filter(number => number.length > 0);
};

export const getCurrentPlanDetailsFromServiceDetails = (serviceDetails) => {
  const uniqueCurrentPlanNames = [];
  serviceDetails.forEach((service) => {
    if (uniqueCurrentPlanNames.includes(service.currentPlan) === false) {
      uniqueCurrentPlanNames.push(service.currentPlan);
    }
  });

  const currentPlanDetails = uniqueCurrentPlanNames.map((plan) => {
    const numberList = getNumbersMatchingCurrentPlan(plan, serviceDetails);
    return {
      planName: plan,
      planTitle: plan,
      numbersOnPlan: numberList,
    };
  });

  const nonUnaddressableServices = currentPlanDetails.filter(planItem => planItem.planName.includes('Unaddressable') === false);
  const unaddressableServices = currentPlanDetails.filter(planItem => planItem.planName.includes('Unaddressable'));

  const finalPlansDetails = [...nonUnaddressableServices, ...unaddressableServices];

  return finalPlansDetails;
};

export const getAllPlansArry = (recommendationContent) => {
  const voicePlansList = recommendationContent.voicePlanNames.split(',').map(planName => (
    { planName: planName.split('|')[0],
      planTitle: recommendationContent[`${planName.split('|')[0]}Staff`].title,
      dataOnly: false,
      numbersOnPlan: [],
    }
  ));
  const broadBandPlansList = recommendationContent.broadBandPlanNames.split(',').map(planName => (
    { planName: planName.split('|')[0],
      planTitle: recommendationContent[`${planName.split('|')[0]}Staff`].title,
      dataOnly: true,
      numbersOnPlan: [],
    }
  ));

  const removePlan = { planName: 'removePlan',
    planTitle: recommendationContent.removePlanText,
    dataOnly: 'all',
    numbersOnPlan: [],
  };
  return voicePlansList.concat(broadBandPlansList, removePlan);
};

export const getAllPlanWithNumber = (serviceDetails) => {
  const planData = {};
  const serviceNumbersWithFlag = {};
  serviceDetails.forEach((service) => {
    if (planData[service.suggestedPlanName] === undefined) {
      planData[service.suggestedPlanName] = { numbersOnPlan: [service.serviceNumber] };
    } else {
      planData[service.suggestedPlanName].numbersOnPlan.push(service.serviceNumber);
    }
    serviceNumbersWithFlag[service.serviceNumber] = {
      dataOnly: service.dataOnly,
      ncServiceType: service.ncServiceType,
      origiPlanName: service.suggestedPlanName === 'removeService' ? 'removePlan' : service.suggestedPlanName,
      planName: service.suggestedPlanName === 'removeService' ? 'removePlan' : service.suggestedPlanName,
      inUse: service.inUse };
  });
  return { planData, serviceNumbersWithFlag };
};

export const getSuggestedPlanDetailsFromServiceDetails = (serviceDetails, recommendationContent) => {
  const { planData, serviceNumbersWithFlag } = getAllPlanWithNumber(serviceDetails);
  const plansList = getAllPlansArry(recommendationContent);

  const removePlanData = serviceDetails.filter(item => item.suggestedPlanName === 'removeService');
  const removeData = getAllPlanWithNumber(removePlanData);

  const suggestedPlan = plansList.map((plan) => {
    const data = plan;
    if (planData[plan.planName] !== undefined) {
      data.numbersOnPlan = planData[plan.planName].numbersOnPlan;
    } else if (plan.planName === 'removePlan') {
      data.numbersOnPlan = removePlanData.length > 0 ? removeData.planData.removeService.numbersOnPlan : [];
    }
    return data;
  });

  const unaddressableData = serviceDetails.filter(item => item.suggestedPlanName === 'unaddressableServices');
  const unaddressData = getAllPlanWithNumber(unaddressableData);
  const unaddressablePlanTitle = unaddressableData.length > 0 && unaddressableData[0].currentPlan;

  const unaddressObject = {
    planName: 'unaddressableServices',
    planTitle: unaddressablePlanTitle,
    dataOnly: 'uns',
    numbersOnPlan: unaddressableData.length > 0 && unaddressData.planData.unaddressableServices.numbersOnPlan,
  };
  if (unaddressableData.length > 0) {
    suggestedPlan.push(unaddressObject);
  }

  const enterpriseWirelessData = serviceDetails.filter(item => item.suggestedPlanName === 'mobileEnterpriseWireless');
  const wirelessData = getAllPlanWithNumber(enterpriseWirelessData);

  const wirelessObject = {
    planName: 'mobileEnterpriseWireless',
    planTitle: recommendationContent.mobileEnterpriseWirelessStaff.title,
    dataOnly: 'all',
    numbersOnPlan: enterpriseWirelessData.length > 0 && wirelessData.planData.mobileEnterpriseWireless.numbersOnPlan,
  };

  if (enterpriseWirelessData.length > 0) {
    suggestedPlan.push(wirelessObject);
  }

  return {
    serviceNumbersWithFlag,
    suggestedPlan,
  };
};

export const preparePostCallForOptimizePlan = (updatedPlan, recommendationContent) => {
  const removeEmptyPlan = updatedPlan.filter(plan => plan.numbersOnPlan.length > 0 && plan.planName !== 'removePlan'
  && plan.planName !== 'unaddressableServices' && plan.planName !== 'mobileEnterpriseWireless');
  const planDetails = removeEmptyPlan.map(plan => (
    {
      userPlanName: plan.planTitle,
      numberOfServices: plan.numbersOnPlan.length,
      cost: recommendationContent[`${plan.planName}Staff`].voiceCost,
      data: recommendationContent[`${plan.planName}Staff`].dataCost,
      dataOnly: plan.dataOnly,
      listOfServices: plan.numbersOnPlan,
    }
  ));
  return { planDetails };
};

export const getOptimizePlanWithNumber = (serviceDetails, serviceNumbersWithFlag) => {
  const planData = {};
  const updatedServiceNumbersWithFlag = serviceNumbersWithFlag;
  serviceDetails.forEach((service) => {
    planData[service.userPlanName] = { numbersOnPlan: service.listOfServices };
    service.listOfServices.forEach((number) => {
      updatedServiceNumbersWithFlag[number].planName = service.userPlanName;
    });
  });

  return { planData, updatedServiceNumbersWithFlag };
};


export const getOptimizePlanDetails = (optimizePlanData, suggestedPlanDetails, serviceNumbersWithFlag) => {
  const { planData, updatedServiceNumbersWithFlag } = getOptimizePlanWithNumber(optimizePlanData.planDetails, serviceNumbersWithFlag);

  const suggestedPlan = suggestedPlanDetails.map((plan) => {
    const data = plan;
    if (planData[plan.planName] !== undefined) {
      data.numbersOnPlan = planData[plan.planName].numbersOnPlan;
    } else if (plan.planName === 'unaddressableServices') {
      data.numbersOnPlan = plan.numbersOnPlan;
    } else if (plan.planName === 'mobileEnterpriseWireless') {
      data.numbersOnPlan = plan.numbersOnPlan;
    } else if (plan.planName !== 'removePlan') {
      data.numbersOnPlan = [];
    }
    return data;
  });
  return {
    updatedServiceNumbersWithFlag,
    suggestedPlan,
    totalFutureSpentPerMonth: optimizePlanData.recommendedTotalCost,
    totalFutureDataInclusionPerMonth: optimizePlanData.recommendedTotalData,
  };
};

export const prepareDropDownOptionsArry = (options) => {
  const prepareOptions = options.map(option => (
    {
      displayText: option.value,
      itemId: option.key,
    }
  ));
  return prepareOptions;
};

export const totalTradeValueCalculation = (serviceNumberDetails, motifOption, tradeInDevice) => {
  console.log(serviceNumberDetails, motifOption);
  console.log(tradeInDevice);
  return {
    totalTradeValue: 100,
    fundContributionValue: 200,
  };
};

export const calculateMotif = (formFields, suggestedPlanDetails) => {
  const { motif, motifEnh, motifEss, motifBBEpic, motifBBEnh, motifBBEss, motifWireless } = formFields;
  const motifHHEpicOptions = motif.options;
  let motifHHEpicValue = '0';
  const hhEpicCount = suggestedPlanDetails.length > 0 &&
   suggestedPlanDetails.find(plan => plan.planName === 'mobileEpic').numbersOnPlan.length;
  motifHHEpicOptions.forEach((opt) => {
    const motifRangeArr = opt.key.split('|');
    const startVal = parseInt(motifRangeArr[0], 10);
    const endVal = parseInt(motifRangeArr[1], 10);
    if (hhEpicCount >= startVal && hhEpicCount <= endVal) {
      motifHHEpicValue = opt.value;
    }
  });


  const motifBBEpicOptions = motifBBEpic.options;
  let motifBBEpicValue = '0';
  const bbEpicCount = suggestedPlanDetails.length > 0 &&
   suggestedPlanDetails.find(plan => plan.planName === 'mobileBroadBandEpic').numbersOnPlan.length;
  motifBBEpicOptions.forEach((opt) => {
    const motifRangeArr = opt.key.split('|');
    const startVal = parseInt(motifRangeArr[0], 10);
    const endVal = parseInt(motifRangeArr[1], 10);
    if (bbEpicCount >= startVal && bbEpicCount <= endVal) {
      motifBBEpicValue = opt.value;
    }
  });


  let motifHHEnhancedValue = '0';
  const motifHHEnhancedOptions = motifEnh.options;
  const hhEnhancedCount = suggestedPlanDetails.length > 0 &&
   suggestedPlanDetails.find(plan => plan.planName === 'mobileEnhanced').numbersOnPlan.length;
  motifHHEnhancedOptions.forEach((opt) => {
    const motifRangeArr = opt.key.split('|');
    const startVal = parseInt(motifRangeArr[0], 10);
    const endVal = parseInt(motifRangeArr[1], 10);
    if (hhEnhancedCount >= startVal && hhEnhancedCount <= endVal) {
      motifHHEnhancedValue = opt.value;
    }
  });


  let motifBBEnhancedValue = '0';
  const motifBBEnhancedOptions = motifBBEnh.options;
  const bbEnhancedCount = suggestedPlanDetails.length > 0 &&
  suggestedPlanDetails.find(plan => plan.planName === 'mobileBroadBandEnhanced').numbersOnPlan.length;
  motifBBEnhancedOptions.forEach((opt) => {
    const motifRangeArr = opt.key.split('|');
    const startVal = parseInt(motifRangeArr[0], 10);
    const endVal = parseInt(motifRangeArr[1], 10);
    if (bbEnhancedCount >= startVal && bbEnhancedCount <= endVal) {
      motifBBEnhancedValue = opt.value;
    }
  });


  let motifHHEssentialValue = '0';
  const motifHHEssentialOptions = motifEss.options;
  const hhEssentialCount = suggestedPlanDetails.length > 0 &&
    suggestedPlanDetails.find(plan => plan.planName === 'mobileEssential').numbersOnPlan.length;
  motifHHEssentialOptions.forEach((opt) => {
    const motifRangeArr = opt.key.split('|');
    const startVal = parseInt(motifRangeArr[0], 10);
    const endVal = parseInt(motifRangeArr[1], 10);
    if (hhEssentialCount >= startVal && hhEssentialCount <= endVal) {
      motifHHEssentialValue = opt.value;
    }
  });

  let motifBBEssentialValue = '0';
  const motifBBEssentialOptions = motifBBEss.options;
  const bbEssentialCount = suggestedPlanDetails.length > 0 &&
    suggestedPlanDetails.find(plan => plan.planName === 'mobileBroadBandEssential').numbersOnPlan.length;
  motifBBEssentialOptions.forEach((opt) => {
    const motifRangeArr = opt.key.split('|');
    const startVal = parseInt(motifRangeArr[0], 10);
    const endVal = parseInt(motifRangeArr[1], 10);
    if (bbEssentialCount >= startVal && bbEssentialCount <= endVal) {
      motifBBEssentialValue = opt.value;
    }
  });

  let motifWirelessValue = '0';
  let wirelessCount = 0;
  const motifWirelessOptions = motifWireless.options;
  const wirelessPlan = suggestedPlanDetails.length > 0 &&
    suggestedPlanDetails.find(plan => plan.planName === 'mobileEnterpriseWireless');
  if (wirelessPlan) {
    wirelessCount = wirelessPlan.numbersOnPlan.length;
  }
  motifWirelessOptions.forEach((opt) => {
    const motifRangeArr = opt.key.split('|');
    const startVal = parseInt(motifRangeArr[0], 10);
    const endVal = parseInt(motifRangeArr[1], 10);
    if (wirelessCount >= startVal && wirelessCount <= endVal) {
      motifWirelessValue = opt.value;
    }
  });

  const finalMotif = ((motifWirelessValue * wirelessCount) +
  (motifBBEssentialValue * bbEssentialCount) +
  (motifHHEssentialValue * hhEssentialCount) +
  (motifBBEnhancedValue * bbEnhancedCount) +
  (motifHHEnhancedValue * hhEnhancedCount) +
  (motifBBEpicValue * bbEpicCount) +
  (motifHHEpicValue * hhEpicCount)
  ) / (wirelessCount +
    bbEssentialCount +
    hhEssentialCount +
    bbEnhancedCount +
    hhEnhancedCount +
    bbEpicCount +
    hhEpicCount
  );

  return parseFloat(finalMotif.toFixed(2));
};

export const calculateAverageAfsPerMonth = (afsContent, newDeviceData, contractTerm) => {
  const newDeviceValuesArr = Object.values(newDeviceData).filter(val => val !== 'NOSELECTION');

  let totalAFSValue = 0;
  newDeviceValuesArr.forEach((device) => {
    const deviceAfsKey = `${device}|${contractTerm}`;
    const afsOption = afsContent.options.find(opt => opt.key === deviceAfsKey);
    totalAFSValue += parseFloat(afsOption.value);
  });
  if (newDeviceValuesArr.length > 0) {
    const finalValue = (totalAFSValue / newDeviceValuesArr.length).toFixed(2);
    return parseFloat(finalValue);
  }
  return 0;
};

export const calculateTotalSavingPerMonth = (phoneCost, newDeviceData, contractTerm) => {
  const newDeviceValuesArr = Object.values(newDeviceData).filter(val => val !== 'NOSELECTION');

  let totalSaving = 0;
  newDeviceValuesArr.forEach((device) => {
    const phoneOption = phoneCost.options.find(opt => opt.key === device);
    totalSaving += parseFloat(phoneOption.value);
  });
  totalSaving /= contractTerm;
  if (newDeviceValuesArr.length > 0) {
    return totalSaving / newDeviceValuesArr.length;
  }
  return 0;
};


export const calculateMonthlyMoorupPerService = (tradeInDevicesData, serviceNumberData, newDeviceData, contractTerm) => {
  let totalTradeInValue = 0;
  const newDeviceCount = Object.values(newDeviceData).filter(val => val !== 'NOSELECTION').length;
  const tradeInDeviceDataArr = Object.entries(tradeInDevicesData);
  tradeInDeviceDataArr.forEach(([key, value]) => {
    if (value) {
      const serviceItem = serviceNumberData.find(service => service.serviceNumber === key);
      if (serviceItem) {
        totalTradeInValue += parseFloat(serviceItem.tradeInValue);
      }
    }
  });

  const monthlyMoorup24Months = totalTradeInValue / parseInt(contractTerm, 10);
  if (newDeviceCount > 0) {
    const finalValue = (monthlyMoorup24Months / newDeviceCount).toFixed(2);
    return parseFloat(finalValue);
  }
  return 0;
};

export const calculateTotalTradeInValue = (tradeInDevicesData, serviceNumberData) => {
  let totalTradeInValue = 0;
  const tradeInDeviceDataArr = Object.entries(tradeInDevicesData);
  tradeInDeviceDataArr.forEach(([key, value]) => {
    if (value) {
      const serviceItem = serviceNumberData.find(service => service.serviceNumber === key);
      if (serviceItem) {
        totalTradeInValue += parseFloat(serviceItem.tradeInValue);
      }
    }
  });

  return totalTradeInValue;
};

export const getDataOptimization = (dataDetails, totalAvailableCost, totalDataServicesCount, normalOptimize = false) => {
  let availableSpend = 0;
  let optimizeDataPlan = 'noPlanFound';
  let optimizedPlans = [];

  const {
    mobileBroadBandEssVoiceCost,
    mobileBroadBandEnhVoiceCost,
    mobileBroadBandEpicVoiceCost,
  } = dataDetails;

  if (totalAvailableCost > (mobileBroadBandEpicVoiceCost * totalDataServicesCount)) {
    availableSpend = totalAvailableCost - (mobileBroadBandEpicVoiceCost * totalDataServicesCount);
    optimizeDataPlan = 'mobileBroadBandEpic';
    optimizedPlans.push({
      planName: 'mobileBroadBandEpic',
      devicesCount: totalDataServicesCount,
      deviceType: 'BB',
    });
  } else if (totalAvailableCost > (mobileBroadBandEnhVoiceCost * totalDataServicesCount)) {
    availableSpend = totalAvailableCost - (mobileBroadBandEnhVoiceCost * totalDataServicesCount);
    optimizeDataPlan = 'mobileBroadBandEnhanced';
    optimizedPlans.push({
      planName: 'mobileBroadBandEnhanced',
      devicesCount: totalDataServicesCount,
      deviceType: 'BB',
    });
  } else if (totalAvailableCost > (mobileBroadBandEssVoiceCost * totalDataServicesCount)) {
    availableSpend = totalAvailableCost - (mobileBroadBandEssVoiceCost * totalDataServicesCount);
    optimizeDataPlan = 'mobileBroadBandEssential';
    optimizedPlans.push({
      planName: 'mobileBroadBandEssential',
      devicesCount: totalDataServicesCount,
      deviceType: 'BB',
    });
  } else {
    availableSpend = totalAvailableCost - (mobileBroadBandEssVoiceCost * totalDataServicesCount);
    optimizeDataPlan = 'mobileBroadBandEssential';
    optimizedPlans.push({
      planName: 'mobileBroadBandEssential',
      devicesCount: totalDataServicesCount,
      deviceType: 'BB',
    });
  }

  if (normalOptimize === false) {
    if (optimizeDataPlan === 'mobileBroadBandEnhanced'
    && Math.floor(availableSpend / (mobileBroadBandEpicVoiceCost - mobileBroadBandEnhVoiceCost)) > 0) {
      const costDiffEpicAndEnh = mobileBroadBandEpicVoiceCost - mobileBroadBandEnhVoiceCost;
      const potentialDevicesToBeUpgraded = Math.floor(availableSpend / costDiffEpicAndEnh);
      optimizedPlans = [];
      optimizedPlans.push({
        planName: 'mobileBroadBandEpic',
        devicesCount: potentialDevicesToBeUpgraded,
        deviceType: 'BB',
      });
      optimizedPlans.push({
        planName: 'mobileBroadBandEnhanced',
        devicesCount: totalDataServicesCount - potentialDevicesToBeUpgraded,
        deviceType: 'BB',
      });
    } else if (optimizeDataPlan === 'mobileBroadBandEssential'
      && Math.floor(availableSpend / (mobileBroadBandEnhVoiceCost - mobileBroadBandEssVoiceCost)) > 0) {
      const costDiffEnhAndEss = mobileBroadBandEnhVoiceCost - mobileBroadBandEssVoiceCost;
      const potentialDevicesToBeUpgraded = Math.floor(availableSpend / costDiffEnhAndEss);
      optimizedPlans = [];
      optimizedPlans.push({
        planName: 'mobileBroadBandEnhanced',
        devicesCount: potentialDevicesToBeUpgraded,
        deviceType: 'BB',
      });
      optimizedPlans.push({
        planName: 'mobileBroadBandEssential',
        devicesCount: totalDataServicesCount - potentialDevicesToBeUpgraded,
        deviceType: 'BB',
      });
    }
  }

  return optimizedPlans;
};

export const getVoiceOptimization = (voiceDetails, totalAvailableCost, totalVoiceServicesCount, normalOptimize = false) => {
  let availableSpend = 0;
  let optimizeVoicePlan = 'noPlanFound';


  let optimizedPlans = [];
  const {
    mobileEssVoiceCost,
    mobileEnhVoiceCost,
    mobileEpicVoiceCost,
  } = voiceDetails;

  if (totalAvailableCost > (mobileEpicVoiceCost * totalVoiceServicesCount)) {
    availableSpend = totalAvailableCost - (mobileEpicVoiceCost * totalVoiceServicesCount);
    optimizeVoicePlan = 'mobileEpic';
    optimizedPlans.push({
      planName: 'mobileEpic',
      devicesCount: totalVoiceServicesCount,
      deviceType: 'HH',
    });
  } else if (totalAvailableCost > (mobileEnhVoiceCost * totalVoiceServicesCount)) {
    availableSpend = totalAvailableCost - (mobileEnhVoiceCost * totalVoiceServicesCount);
    optimizeVoicePlan = 'mobileEnhanced';
    optimizedPlans.push({
      planName: 'mobileEnhanced',
      devicesCount: totalVoiceServicesCount,
      deviceType: 'HH',
    });
  } else if (totalAvailableCost > (mobileEssVoiceCost * totalVoiceServicesCount)) {
    availableSpend = totalAvailableCost - (mobileEssVoiceCost * totalVoiceServicesCount);
    optimizeVoicePlan = 'mobileEssential';
    optimizedPlans.push({
      planName: 'mobileEssential',
      devicesCount: totalVoiceServicesCount,
      deviceType: 'HH',
    });
  } else {
    availableSpend = totalAvailableCost - (mobileEssVoiceCost * totalVoiceServicesCount);
    optimizeVoicePlan = 'mobileEssential';
    optimizedPlans.push({
      planName: 'mobileEssential',
      devicesCount: totalVoiceServicesCount,
      deviceType: 'HH',
    });
  }

  if (normalOptimize === false) {
    if (optimizeVoicePlan === 'mobileEnhanced' && Math.floor(availableSpend / (mobileEpicVoiceCost - mobileEnhVoiceCost)) > 0) {
      const costDiffEpicAndEnh = mobileEpicVoiceCost - mobileEnhVoiceCost;
      const potentialDevicesToBeUpgraded = Math.floor(availableSpend / costDiffEpicAndEnh);
      optimizedPlans = [];
      optimizedPlans.push({
        planName: 'mobileEpic',
        devicesCount: potentialDevicesToBeUpgraded,
        deviceType: 'HH',
      });
      optimizedPlans.push({
        planName: 'mobileEnhanced',
        devicesCount: totalVoiceServicesCount - potentialDevicesToBeUpgraded,
        deviceType: 'HH',
      });
    } else if (optimizeVoicePlan === 'mobileEssential' && Math.floor(availableSpend / (mobileEnhVoiceCost - mobileEssVoiceCost)) > 0) {
      const costDiffEnhAndEss = mobileEnhVoiceCost - mobileEssVoiceCost;
      const potentialDevicesToBeUpgraded = Math.floor(availableSpend / costDiffEnhAndEss);
      optimizedPlans = [];
      optimizedPlans.push({
        planName: 'mobileEnhanced',
        devicesCount: potentialDevicesToBeUpgraded,
        deviceType: 'HH',
      });
      optimizedPlans.push({
        planName: 'mobileEssential',
        devicesCount: totalVoiceServicesCount - potentialDevicesToBeUpgraded,
        deviceType: 'HH',
      });
    }
  }

  return optimizedPlans;
};

export const getVoiceAndDataOptimization = (voiceDetails, dataDetails, totalAvailableCost, totalVoiceServicesCount, totalDataServicesCount) => {
  let availableSpend = 0;

  let optimizedPlans = [];
  const {
    mobileEssVoiceCost,
    mobileEnhVoiceCost,
    mobileEpicVoiceCost,
  } = voiceDetails;

  // voice devices optimization
  if (totalAvailableCost > (mobileEpicVoiceCost * totalVoiceServicesCount)) {
    availableSpend = totalAvailableCost - (mobileEpicVoiceCost * totalVoiceServicesCount);
    optimizedPlans.push({
      planName: 'mobileEpic',
      devicesCount: totalVoiceServicesCount,
      deviceType: 'HH',
    });
  } else if (totalAvailableCost > (mobileEnhVoiceCost * totalVoiceServicesCount)) {
    availableSpend = totalAvailableCost - (mobileEnhVoiceCost * totalVoiceServicesCount);
    optimizedPlans.push({
      planName: 'mobileEnhanced',
      devicesCount: totalVoiceServicesCount,
      deviceType: 'HH',
    });
  } else if (totalAvailableCost > (mobileEssVoiceCost * totalVoiceServicesCount)) {
    availableSpend = totalAvailableCost - (mobileEssVoiceCost * totalVoiceServicesCount);
    optimizedPlans.push({
      planName: 'mobileEssential',
      devicesCount: totalVoiceServicesCount,
      deviceType: 'HH',
    });
  } else {
    availableSpend = totalAvailableCost - (mobileEssVoiceCost * totalVoiceServicesCount);
    optimizedPlans.push({
      planName: 'mobileEssential',
      devicesCount: totalVoiceServicesCount,
      deviceType: 'HH',
    });
  }

  // data devices optimization

  const {
    mobileBroadBandEssVoiceCost,
    mobileBroadBandEnhVoiceCost,
    mobileBroadBandEpicVoiceCost,
  } = dataDetails;

  if (availableSpend > (mobileBroadBandEpicVoiceCost * totalDataServicesCount)) {
    availableSpend -= (mobileBroadBandEpicVoiceCost * totalDataServicesCount);
    optimizedPlans.push({
      planName: 'mobileBroadBandEpic',
      devicesCount: totalDataServicesCount,
      deviceType: 'BB',
    });
  } else if (availableSpend > (mobileBroadBandEnhVoiceCost * totalDataServicesCount)) {
    availableSpend -= (mobileBroadBandEnhVoiceCost * totalDataServicesCount);
    optimizedPlans.push({
      planName: 'mobileBroadBandEnhanced',
      devicesCount: totalDataServicesCount,
      deviceType: 'BB',
    });
  } else if (availableSpend > (mobileBroadBandEssVoiceCost * totalDataServicesCount)) {
    availableSpend -= (mobileBroadBandEssVoiceCost * totalDataServicesCount);
    optimizedPlans.push({
      planName: 'mobileBroadBandEssential',
      devicesCount: totalDataServicesCount,
      deviceType: 'BB',
    });
  } else {
    availableSpend -= (mobileBroadBandEssVoiceCost * totalDataServicesCount);
    optimizedPlans.push({
      planName: 'mobileBroadBandEssential',
      devicesCount: totalDataServicesCount,
      deviceType: 'BB',
    });
  }

  // further voice optimization
  const existingVoicePlan = optimizedPlans.find(plan => plan.deviceType === 'HH');
  if (Math.floor(availableSpend / (mobileEpicVoiceCost - mobileEnhVoiceCost)) > 0
    && existingVoicePlan.planName === 'mobileEnhanced') {
    const costDiffEpicAndEnh = mobileEpicVoiceCost - mobileEnhVoiceCost;
    const potentialDevicesToBeUpgraded = Math.floor(availableSpend / costDiffEpicAndEnh);
    optimizedPlans = optimizedPlans.filter(plan => plan.deviceType !== 'HH');
    optimizedPlans.push({
      planName: 'mobileEpic',
      devicesCount: potentialDevicesToBeUpgraded,
      deviceType: 'HH',
    });
    optimizedPlans.push({
      planName: 'mobileEnhanced',
      devicesCount: totalVoiceServicesCount - potentialDevicesToBeUpgraded,
      deviceType: 'HH',
    });

    const moneyUsed = (potentialDevicesToBeUpgraded * mobileEpicVoiceCost) +
    ((totalVoiceServicesCount - potentialDevicesToBeUpgraded) * mobileEnhVoiceCost);

    availableSpend -= moneyUsed;
  } else if (Math.floor(availableSpend / (mobileEnhVoiceCost - mobileEssVoiceCost)) > 0
    && existingVoicePlan.planName === 'mobileEssential') {
    const costDiffEnhAndEss = mobileEnhVoiceCost - mobileEssVoiceCost;
    const potentialDevicesToBeUpgraded = Math.floor(availableSpend / costDiffEnhAndEss);
    optimizedPlans = optimizedPlans.filter(plan => plan.deviceType !== 'HH');
    optimizedPlans.push({
      planName: 'mobileEnhanced',
      devicesCount: potentialDevicesToBeUpgraded,
      deviceType: 'HH',
    });
    optimizedPlans.push({
      planName: 'mobileEssential',
      devicesCount: totalVoiceServicesCount - potentialDevicesToBeUpgraded,
      deviceType: 'HH',
    });

    const moneyUsed = (potentialDevicesToBeUpgraded * mobileEnhVoiceCost) +
    ((totalVoiceServicesCount - potentialDevicesToBeUpgraded) * mobileEssVoiceCost);

    availableSpend -= moneyUsed;
  }

  // further data optimization
  const existingDataPlan = optimizedPlans.find(plan => plan.deviceType === 'BB');
  if (existingDataPlan.planName === 'mobileBroadBandEnhanced'
    && Math.floor(availableSpend / (mobileBroadBandEpicVoiceCost - mobileBroadBandEnhVoiceCost)) > 0) {
    const costDiffEpicAndEnh = mobileBroadBandEpicVoiceCost - mobileBroadBandEnhVoiceCost;
    const potentialDevicesToBeUpgraded = Math.floor(availableSpend / costDiffEpicAndEnh);
    optimizedPlans = optimizedPlans.filter(plan => plan.deviceType !== 'BB');
    optimizedPlans.push({
      planName: 'mobileBroadBandEpic',
      devicesCount: potentialDevicesToBeUpgraded,
      deviceType: 'BB',
    });
    optimizedPlans.push({
      planName: 'mobileBroadBandEnhanced',
      devicesCount: totalDataServicesCount - potentialDevicesToBeUpgraded,
      deviceType: 'BB',
    });
  } else if (existingDataPlan.planName === 'mobileBroadBandEssential'
    && Math.floor(availableSpend / (mobileBroadBandEnhVoiceCost - mobileBroadBandEssVoiceCost)) > 0) {
    const costDiffEnhAndEss = mobileBroadBandEnhVoiceCost - mobileBroadBandEssVoiceCost;
    const potentialDevicesToBeUpgraded = Math.floor(availableSpend / costDiffEnhAndEss);
    optimizedPlans = optimizedPlans.filter(plan => plan.deviceType !== 'BB');
    optimizedPlans.push({
      planName: 'mobileBroadBandEnhanced',
      devicesCount: potentialDevicesToBeUpgraded,
      deviceType: 'BB',
    });
    optimizedPlans.push({
      planName: 'mobileBroadBandEssential',
      devicesCount: totalDataServicesCount - potentialDevicesToBeUpgraded,
      deviceType: 'BB',
    });
  }

  return optimizedPlans;
};


export const getFEOptimizeResult = (updatedPlan, recommendationContent, totalAvailableCost) => {
  const removeEmptyPlan = updatedPlan.filter(plan => plan.numbersOnPlan.length > 0 && plan.planName !== 'removePlan'
  && plan.planName !== 'unaddressableServices' && plan.planName !== 'mobileEnterpriseWireless');

  console.log('total cost before remnoving mobile wireless:', totalAvailableCost);

  const mobileWirelessVoiceCost = parseInt(recommendationContent.mobileEnterpriseWirelessStaff.voiceCost, 10);
  const mobileWirelessDataCost = parseInt(recommendationContent.mobileEnterpriseWirelessStaff.dataCost, 10);

  let mobileWirelessServicesCount = 0;
  const mobileWirelessPlan = updatedPlan.find(plan => plan.planName === 'mobileEnterpriseWireless');
  if (mobileWirelessPlan) {
    mobileWirelessServicesCount = mobileWirelessPlan.numbersOnPlan.length;
  }

  totalAvailableCost -= (mobileWirelessServicesCount * mobileWirelessVoiceCost); // eslint-disable-line

  console.log('total cost after remnoving mobile wireless:', totalAvailableCost);

  let totalVoiceServicesCount = 0;
  removeEmptyPlan.filter(serviceItem => serviceItem.dataOnly === false)
    .forEach((items) => {
      totalVoiceServicesCount += items.numbersOnPlan.length;
    });

  let totalDataServicesCount = 0;
  removeEmptyPlan.filter(serviceItem => serviceItem.dataOnly === true)
    .forEach((items) => {
      totalDataServicesCount += items.numbersOnPlan.length;
    });


  const mobileBroadBandEssVoiceCost = parseInt(recommendationContent.mobileBroadBandEssentialStaff.voiceCost, 10);
  const mobileBroadBandEssDataCost = parseInt(recommendationContent.mobileBroadBandEssentialStaff.dataCost, 10);

  const mobileBroadBandEnhVoiceCost = parseInt(recommendationContent.mobileBroadBandEnhancedStaff.voiceCost, 10);
  const mobileBroadBandEnhDataCost = parseInt(recommendationContent.mobileBroadBandEnhancedStaff.dataCost, 10);

  const mobileBroadBandEpicVoiceCost = parseInt(recommendationContent.mobileBroadBandEpicStaff.voiceCost, 10);
  const mobileBroadBandEpicDataCost = parseInt(recommendationContent.mobileBroadBandEpicStaff.dataCost, 10);

  const mobileEssVoiceCost = parseInt(recommendationContent.mobileEssentialStaff.voiceCost, 10);
  const mobileEssDataCost = parseInt(recommendationContent.mobileEssentialStaff.dataCost, 10);

  const mobileEnhVoiceCost = parseInt(recommendationContent.mobileEnhancedStaff.voiceCost, 10);
  const mobileEnhDataCost = parseInt(recommendationContent.mobileEnhancedStaff.dataCost, 10);

  const mobileEpicVoiceCost = parseInt(recommendationContent.mobileEpicStaff.voiceCost, 10);
  const mobileEpicDataCost = parseInt(recommendationContent.mobileEpicStaff.dataCost, 10);

  const voiceDetails = {
    mobileEssVoiceCost,
    mobileEssDataCost,
    mobileEnhVoiceCost,
    mobileEnhDataCost,
    mobileEpicVoiceCost,
    mobileEpicDataCost,
  };

  const dataDetails = {
    mobileBroadBandEssVoiceCost,
    mobileBroadBandEssDataCost,
    mobileBroadBandEnhVoiceCost,
    mobileBroadBandEnhDataCost,
    mobileBroadBandEpicVoiceCost,
    mobileBroadBandEpicDataCost,
  };

  let optimizedResults = [];

  if (totalDataServicesCount === 0) {
    optimizedResults = getVoiceOptimization(voiceDetails, totalAvailableCost, totalVoiceServicesCount);
  } else if (totalVoiceServicesCount === 0) {
    optimizedResults = getDataOptimization(dataDetails, totalAvailableCost, totalDataServicesCount);
  } else {
    optimizedResults = getVoiceAndDataOptimization(voiceDetails, dataDetails, totalAvailableCost, totalVoiceServicesCount, totalDataServicesCount);
  }

  const totalCost = optimizedResults.reduce((acc, plan) =>
    acc + (parseInt(recommendationContent[`${plan.planName}Staff`].voiceCost, 10) * plan.devicesCount), 0);
  const totalData = optimizedResults.reduce((acc, plan) =>
    acc + (parseInt(recommendationContent[`${plan.planName}Staff`].dataCost, 10) * plan.devicesCount), 0);

  console.log('total cost after optimization without wireless:', totalCost);
  return {
    optimizedPlanData: optimizedResults.filter(planItem => planItem.devicesCount > 0),
    totalCost: totalCost + (mobileWirelessServicesCount * mobileWirelessVoiceCost),
    totalData: totalData + (mobileWirelessServicesCount * mobileWirelessDataCost),
  };
};

export const convertOptimizedResultForFE = (optimizedResults, mobileDevicesNumbers, dataDevicesNumbers) => {
  let deviceCount = 0;

  const { optimizedPlanData, totalCost, totalData } = optimizedResults;

  const mobilePlanData = optimizedPlanData.filter(plan => plan.deviceType === 'HH');
  const broadBandPlanData = optimizedPlanData.filter(plan => plan.deviceType === 'BB');

  const mobileDetailsData = mobilePlanData.map((planItem, index) => {
    if (index === 0) {
      deviceCount = 0;
    } else {
      deviceCount = mobilePlanData[index - 1].devicesCount;
    }
    return {
      userPlanName: planItem.planName,
      dataOnly: 'No',
      listOfServices: mobileDevicesNumbers.slice(deviceCount, planItem.devicesCount + deviceCount),
    };
  });

  const broadBandDetailsData = broadBandPlanData.map((planItem, index) => {
    if (index === 0) {
      deviceCount = 0;
    } else {
      deviceCount = broadBandPlanData[index - 1].devicesCount;
    }
    return {
      userPlanName: planItem.planName,
      dataOnly: 'Yes',
      listOfServices: dataDevicesNumbers.slice(deviceCount, planItem.devicesCount + deviceCount),
    };
  });

  const optimizePlanData = {
    planDetails: [...mobileDetailsData, ...broadBandDetailsData],
    recommendedTotalCost: totalCost,
    recommendedTotalData: totalData,
  };

  return optimizePlanData;
};


export const getCurrentDevicesListFromData = (originalData) => {
  const allDevicesList = originalData && originalData.filter(ori => ori.dataOnly === false
    && ori.suggestedPlanName !== 'removeService' && ori.suggestedPlanName !== 'mobileEnterpriseWireless'
    && ori.suggestedPlanName !== 'unaddressableServices').map(itm => itm.deviceType);

  const DevicesUniqueList = [];

  allDevicesList.forEach((itm) => {
    if (DevicesUniqueList.includes(itm) === false && itm.trim().length > 0) {
      DevicesUniqueList.push(itm);
    }
  });

  const currentDevices = DevicesUniqueList.map((itm, index) => {
    const id = `device${index}`;
    const val = itm;
    return {
      itemId: id,
      displayText: val,
    };
  });
  return currentDevices;
};

export const getCurrentPlanListFromData = (originalData) => {
  const allPlansList = originalData && originalData.filter(ori => ori.suggestedPlanName !== 'unaddressableServices'
  && ori.suggestedPlanName !== 'mobileEnterpriseWireless').map(itm => itm.currentPlan);

  const plansUniqueList = [];

  allPlansList.forEach((itm) => {
    if (plansUniqueList.includes(itm) === false && itm.trim().length > 0) {
      plansUniqueList.push(itm);
    }
  });

  const currentPlans = plansUniqueList.map((itm, index) => {
    const id = `plan${index}`;
    const val = itm;
    return {
      itemId: id,
      displayText: val,
    };
  });
  return currentPlans;
};

export const getUnaddressCurrentDevicesList = (originalData) => {
  const allDevicesList = originalData && originalData.filter(ori => ori.suggestedPlanName === 'unaddressableServices')
    .map(itm => itm.deviceType);

  const DevicesUniqueList = [];

  allDevicesList.forEach((itm) => {
    if (DevicesUniqueList.includes(itm) === false && itm.trim().length > 0) {
      DevicesUniqueList.push(itm);
    }
  });

  const currentDevices = DevicesUniqueList.map((itm, index) => {
    const id = `device${index}`;
    const val = itm;
    return {
      itemId: id,
      displayText: val,
    };
  });
  return currentDevices;
};

export const getUnaddressTreatmentList = (originalData) => {
  const allPlansList = originalData && originalData.filter(ori => ori.suggestedPlanName === 'unaddressableServices')
    .map(itm => itm.treatmentName);

  const plansUniqueList = [];

  allPlansList.forEach((itm) => {
    if (plansUniqueList.includes(itm) === false && itm.trim().length > 0) {
      plansUniqueList.push(itm);
    }
  });

  const treatmentPlans = plansUniqueList.map((itm, index) => {
    const id = `plan${index}`;
    const val = itm;
    return {
      itemId: id,
      displayText: val,
    };
  });
  return treatmentPlans;
};


export const getUnaddressCurrentPlanList = (originalData) => {
  const allPlansList = originalData && originalData.filter(ori => ori.suggestedPlanName === 'unaddressableServices')
    .map(itm => itm.unaddressableCurrentPlan);

  const plansUniqueList = [];

  allPlansList.forEach((itm) => {
    if (plansUniqueList.includes(itm) === false && itm.trim().length > 0) {
      plansUniqueList.push(itm);
    }
  });

  const currentPlans = plansUniqueList.map((itm, index) => {
    const id = `plan${index}`;
    const val = itm;
    return {
      itemId: id,
      displayText: val,
    };
  });
  return currentPlans;
};

export const getWirelessCurrentPlanList = (originalData) => {
  const allPlansList = originalData && originalData.filter(ori => ori.suggestedPlanName === 'mobileEnterpriseWireless')
    .map(itm => itm.currentPlan);

  const plansUniqueList = [];

  allPlansList.forEach((itm) => {
    if (plansUniqueList.includes(itm) === false && itm.trim().length > 0) {
      plansUniqueList.push(itm);
    }
  });

  const currentPlans = plansUniqueList.map((itm, index) => {
    const id = `plan${index}`;
    const val = itm;
    return {
      itemId: id,
      displayText: val,
    };
  });
  return currentPlans;
};

export const getWirelessCurrentDevicesList = (originalData) => {
  const allDevicesList = originalData && originalData.filter(ori => ori.suggestedPlanName === 'mobileEnterpriseWireless')
    .map(itm => itm.deviceType);

  const DevicesUniqueList = [];

  allDevicesList.forEach((itm) => {
    if (DevicesUniqueList.includes(itm) === false && itm.trim().length > 0) {
      DevicesUniqueList.push(itm);
    }
  });

  const currentDevices = DevicesUniqueList.map((itm, index) => {
    const id = `device${index}`;
    const val = itm;
    return {
      itemId: id,
      displayText: val,
    };
  });
  return currentDevices;
};

export const calculateAddonCosts = (
  iDOPlanDropDownValue,
  voice2TextCheckboxVal,
  iPhoneMsgBankCheckboxVal,
  oneNumberCheckboxVal,
  monthPassCheckboxVal,
  acceleratorCheckboxVal,
  dataTopUpDropDownValue,
  demandDataCheckboxVal,
  costAuthorability,
  serviceNumberWithFlag,
) => {
  let addonCost = 0;
  const costOptions = costAuthorability.formFields;
  const iddPlanDataArr = Object.entries(iDOPlanDropDownValue);
  const voice2TextDataArr = Object.entries(voice2TextCheckboxVal);
  const msgBankDataArr = Object.entries(iPhoneMsgBankCheckboxVal);
  const oneNumberDataArr = Object.entries(oneNumberCheckboxVal);
  const monthPassDataArr = Object.entries(monthPassCheckboxVal);
  const acceleratorDataArr = Object.entries(acceleratorCheckboxVal);
  const dataTopUpDataArr = Object.entries(dataTopUpDropDownValue);
  const demandDataArr = Object.entries(demandDataCheckboxVal);

  /*eslint-disable */
  iddPlanDataArr && iddPlanDataArr.forEach(([key, value]) => {
    if (value) {
      const costItem = costOptions.addonIddPacksCosts.options.find(cost => iDOPlanDropDownValue[key] === cost.key);
      if (costItem) {
        addonCost += parseFloat(costItem.value);
      }
    }
  });
  voice2TextDataArr && voice2TextDataArr.forEach(([key, value]) => {
    if (value) {
      const costItem = costOptions.addonVoice2TextCost.options[0];
      if (costItem) {
        addonCost += parseFloat(costItem.value);
      }
    }
  });
  msgBankDataArr && msgBankDataArr.forEach(([key, value]) => {
    if (value) {
      const costItem = costOptions.messageBankCost.options[0];
      if (costItem) {
        addonCost += parseFloat(costItem.value);
      }
    }
  });
  oneNumberDataArr && oneNumberDataArr.forEach(([key, value]) => {
    if (value) {
      const costItem = costOptions.addonOneNumberCost.options[0];
      if (costItem) {
        addonCost += parseFloat(costItem.value);
      }
    }
  });
  monthPassDataArr && monthPassDataArr.forEach(([key, value]) => {
    if (value) {
      const costItem = costOptions.addonMonthPassCost.options[0];
      if (costItem) {
        addonCost += parseFloat(costItem.value);
      }
    }
  });
  acceleratorDataArr && acceleratorDataArr.forEach(([key, value]) => {
    if (value) {
      const costItem = costOptions.addonAcceleratorCosts.options.find(
        cost => serviceNumberWithFlag[key].planName.toLowerCase().includes(cost.key.toLowerCase())
      );
      if (costItem) {
        addonCost += parseFloat(costItem.value);
      }
    }
  });
  dataTopUpDataArr && dataTopUpDataArr.forEach(([key, value]) => {
    if (value) {
      const costItem = costOptions.dataTopUpCost.options.find(cost => dataTopUpDropDownValue[key] === cost.key);
      if (costItem) {
        addonCost += parseFloat(costItem.value);
      }
    }
  });
  demandDataArr && demandDataArr.forEach(([key, value]) => {
    if (value) {
      const costItem = costOptions.demandDataCost.options[0];
      if (costItem) {
        addonCost += parseFloat(costItem.value);
      }
    }
  });
  /* eslint-enable */
  return addonCost;
};

export const validateNumber = (number) => {
  const regex = /^\d*$/;
  return regex.test(number);
};

export const prepareAmcCallbackData = (callBackPhoneNumber) => {
  const amcCallbackData = { alternateContactNumber: callBackPhoneNumber };
  return amcCallbackData;
};

export const validatePhoneNumberWithStartLetter = (phoneNumber) => {
  const phoneNumberWithoutSpaces = phoneNumber.replace(/[\s]/g, '');
  const regex = /^\(?([0]{1})\)?([23478]{1})([0-9]{8})$/;
  return regex.test(phoneNumberWithoutSpaces);
};

export const successfulSubmissionOfAMCRequestCallback = (response) => {
  const { data } = response;
  return { type: COMPLETE_AMC_CALLBACK_REQUEST, data };
};

export const submitAMCRequestCallback = data => (dispatch) => {
  const endpoint = `${AMC_CALLBACK_REQUEST_ENDPOINT}&value=${encodeURIComponent(window.parent.tcom.researchInsights.appConfig.currentAccount)}`;
  dispatch({ type: INITIATE_AMC_CALLBACK_REQUEST });
  apiPost(dispatch, endpoint, successfulSubmissionOfAMCRequestCallback, failureAction, data);
};


export const getAddonTypeCounts = (stateData) => {
  const {
    iDOPlanDropDownValue,
    dataTopUpDropDownValue,
    mobileEtcDropDownValue,
    voice2TextCheckboxVal,
    iPhoneMsgBankCheckboxVal,
    oneNumberCheckboxVal,
    monthPassCheckboxVal,
    acceleratorCheckboxVal,
    demandDataCheckboxVal,
  } = stateData;

  const iDOCount = Object.keys(iDOPlanDropDownValue).length > 0
    && Object.keys(iDOPlanDropDownValue).some(itm => iDOPlanDropDownValue[itm] !== 'na') ? 1 : 0;
  const dataTopUpCount = Object.keys(dataTopUpDropDownValue).length > 0
    && Object.keys(dataTopUpDropDownValue).some(itm => dataTopUpDropDownValue[itm] !== 'na') ? 1 : 0;
  const mobileEtcCount = Object.keys(mobileEtcDropDownValue).length > 0
    && Object.keys(mobileEtcDropDownValue).some(itm => mobileEtcDropDownValue[itm] !== 'na') ? 1 : 0;
  const voice2TextCount = Object.keys(voice2TextCheckboxVal).length > 0
    && Object.keys(voice2TextCheckboxVal).some(itm => voice2TextCheckboxVal[itm] === true) ? 1 : 0;
  const iPhoneMsgCount = Object.keys(iPhoneMsgBankCheckboxVal).length > 0
    && Object.keys(iPhoneMsgBankCheckboxVal).some(itm => iPhoneMsgBankCheckboxVal[itm] === true) ? 1 : 0;
  const oneNumberCount = Object.keys(oneNumberCheckboxVal).length > 0
    && Object.keys(oneNumberCheckboxVal).some(itm => oneNumberCheckboxVal[itm] === true) ? 1 : 0;
  const monthPassCount = Object.keys(monthPassCheckboxVal).length > 0
    && Object.keys(monthPassCheckboxVal).some(itm => monthPassCheckboxVal[itm] === true) ? 1 : 0;
  const acceleratorCount = Object.keys(acceleratorCheckboxVal).length > 0
    && Object.keys(acceleratorCheckboxVal).some(itm => acceleratorCheckboxVal[itm] === true) ? 1 : 0;
  const demandDataCount = Object.keys(demandDataCheckboxVal).length > 0
    && Object.keys(demandDataCheckboxVal).some(itm => demandDataCheckboxVal[itm] === true) ? 1 : 0;

  return iDOCount + dataTopUpCount + mobileEtcCount + voice2TextCount + iPhoneMsgCount + oneNumberCount + monthPassCount + acceleratorCount + demandDataCount; // eslint-disable-line
};

const getYesNoFromTrueFalse = (itemValue) => {
  let finalValue = 'No';
  if (itemValue !== undefined) {
    finalValue = itemValue === true ? 'Yes' : 'No';
  }
  return finalValue;
};

export const getAddonPostcallForServiceNumber = (serviceNumber, mainState) => {
  const {
    iDOPlanDropDownValue,
    dataTopUpDropDownValue,
    mobileEtcDropDownValue,
    voice2TextCheckboxVal,
    iPhoneMsgBankCheckboxVal,
    oneNumberCheckboxVal,
    monthPassCheckboxVal,
    acceleratorCheckboxVal,
    demandDataCheckboxVal,
  } = mainState;

  const addOnObject = {
    iddPack: iDOPlanDropDownValue[serviceNumber] !== undefined ? iDOPlanDropDownValue[serviceNumber] : 'na',
    voice2Text: getYesNoFromTrueFalse(voice2TextCheckboxVal[serviceNumber]),
    messageBank: getYesNoFromTrueFalse(iPhoneMsgBankCheckboxVal[serviceNumber]),
    oneNumber: getYesNoFromTrueFalse(oneNumberCheckboxVal[serviceNumber]),
    irMonthPass: getYesNoFromTrueFalse(monthPassCheckboxVal[serviceNumber]),
    accelerator: getYesNoFromTrueFalse(acceleratorCheckboxVal[serviceNumber]),
    businessDemandData: getYesNoFromTrueFalse(demandDataCheckboxVal[serviceNumber]),
    dataTopUp: dataTopUpDropDownValue[serviceNumber] !== undefined ? dataTopUpDropDownValue[serviceNumber] : 'na',
    mobileHardwareETC: mobileEtcDropDownValue[serviceNumber] !== undefined ? mobileEtcDropDownValue[serviceNumber] : 'na',
  };

  return addOnObject;
};
